import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Popper from "@mui/material/Popper";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import { Box, CircularProgress } from "@mui/material";
import OrbAvatar from "../../components/orb-avatar";

const CustomPopper = styled(Popper)({
  zIndex: 20000,
});

const StyledInput = styled(TextField)({
  width: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  borderRadius: 8,
  fontFamily: "Mohave, sans-serif",
  "& .MuiOutlinedInput-root": {
    minHeight: "28px",
    paddingTop: "2px",
    paddingBottom: "2px",
    color: "#fff",
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
  "& input": {
    padding: "4px 8px",
    backgroundColor: "transparent",
    color: "#fff",
  },
});

const NoDeleteChip = styled(Chip)({
  backgroundColor: "#fff",
  color: "#000",
  fontFamily: "Mohave, sans-serif",
});

interface Props {
  options: any;
  value: any;
  handleChange: any;
  getoptlabel: any;
  placeholder: string;
  loading?: boolean;
  onOpen?: () => void; // 👈 support onOpen
}

const OrbMultiSelect: React.FC<Props> = ({
  options,
  value,
  handleChange,
  getoptlabel,
  placeholder,
  loading = false,
  onOpen,
}) => {
  return (
    <Autocomplete
      multiple
      options={options}
      value={value}
      onChange={(_, newValue) => handleChange(newValue)}
      getOptionLabel={(option) => getoptlabel(option)}
      isOptionEqualToValue={(option, val) => option.usr_name === val.usr_name}
      filterSelectedOptions
      PopperComponent={CustomPopper}
      disableClearable
      popupIcon={null}
      clearIcon={null}
      loading={loading}
      onOpen={onOpen}
      loadingText="Loading..."
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontFamily: "Mohave, sans-serif",
          }}
        >
          <OrbAvatar file={option.usr_img} />
          {getoptlabel(option)}
        </Box>
      )}
      sx={{ width: "100%" }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <NoDeleteChip
            label={getoptlabel(option)}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <StyledInput
          {...params}
          placeholder={placeholder}
          variant="outlined"
          InputLabelProps={{ shrink: false }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={16} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default OrbMultiSelect;
